import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#556cd6',
    },
    background: {
      default: '#1976d2',
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          transition: 'none !important',
          WebkitTransition: 'none !important',
          MozTransition: 'none !important',
          msTransition: 'none !important',
          OTransition: 'none !important',
          '&&': {
            transition: 'none !important',
          }
        },
      },
    },
  },
}); 